import { TransformDashboard } from 'components/types/dashboard';
import { TransformBoard } from 'components/types/boardList';
import { TransformCompany } from 'components/types/company';
import { TransformBispro } from 'components/types/businessProcess';
import { TransformOrganization } from 'components/types/structure-view/structure';
import { TransformJobDesc } from 'components/types/jobDesc';
import { TransformWlaAnalytics } from 'components/types/wla/wlaAnalytics/types';
import { TransformWlaMonitor } from 'components/types/wla/wlaLanding/type';
import { TransformMatrix } from 'components/types/matrix';
import { TransformBackOffice } from 'components/types/backOffice/company';
import { dashboardLoader } from './dashboard';
import { boardLoader } from './boardList';
import { companyLoader } from './company';
import { bisproLoader } from './businesProcess';
import { organizationLoader } from './organization';
import { jobDescLoader } from './jobDesc';
import { wlaAnalyticsLoader } from './wlaAnalytics';
import { wlaMonitorLoader } from './wlaMonitoring';
import { matrixLoader } from './matrix';
import { BackOfficeLoader } from './BackOffice';

type DataMap = {
  dashboard: TransformDashboard;
  board: TransformBoard;
  company: TransformCompany;
  bispro: TransformBispro;
  organization: TransformOrganization;
  jobDesc: TransformJobDesc;
  wlaAnalytics: TransformWlaAnalytics;
  wlaMonitor: TransformWlaMonitor;
  matrix: TransformMatrix,
  backOffice: TransformBackOffice
};

const data: DataMap = {
  dashboard: dashboardLoader,
  board: boardLoader,
  company: companyLoader,
  bispro: bisproLoader,
  organization: organizationLoader,
  jobDesc: jobDescLoader,
  wlaAnalytics: wlaAnalyticsLoader,
  wlaMonitor: wlaMonitorLoader,
  matrix: matrixLoader,
  backOffice: BackOfficeLoader,
};

type TransformLoader<T extends keyof DataMap> = DataMap[T];

function useTransformLoader() {
  const tf = <T extends keyof DataMap>(key: T): TransformLoader<T> => data[key];
  return {
    tf,
  };
}

export default useTransformLoader;
